<template>
  <div class="content-area">
    <div class="error-panel">
      <infopanel v-once>
        <template slot="title"></template>
        <template slot="body">
          <div class="row">
            <div class="col-sm-12 col-xs-12 warning-text text-center">
              <h1>404 - Not Found</h1>
              <p>Sorry the page you are looking for is not available.</p>
            </div>
          </div>
        </template>
      </infopanel>
    </div>
  </div>
</template>

<script>
import InfoPanel from '@/components/InfoPanel';

export default {
  components: {
    infopanel: InfoPanel,
  },
};
</script>

<style scoped>
.warning-icon {
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .warning-text {
    text-align: center;
  }
  .warning-icon {
    height: 100px;
  }
}

@media (min-width: 481px) {
  .warning-text {
    margin-left: 10px;
    margin-top: 20px;
  }
}

@media (min-width: 767px) {
  .warning-text {
    margin-left: 10px;
    margin-top: 20px;
  }
}
.error-panel {
  margin-top: 140px;
}

/* .content-area {
    min-height: calc(100vh - 305px);
  } */
</style>
